import { RegistryItem } from '../RegistryItem';
export class ValueRegistryItem extends RegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
    value;
    can;
    params;
    get paramsFinal() {
        return this.params;
    }
}
